export const sso = {
  title: `We couldn't log you in...`,
  text: `We encountered an error. We apologize for the inconvenience. Please try logging in again via your Mashreq Visa card page`,
  url: 'https://www.mashreqbank.com/en/uae/personal/',
  button: 'Back to Mashreq',
};
